<template>
  <img :src="logoSrc" class="lti-source-logo" v-if="logoSrc" />
</template>

<script>

const logos = {
  narayana: "https://blob-jiocdn.embibe.com/coobo/school_app_create_prod/images/lti-source-logos/narayana.png",
  ueducate: "https://blob-jiocdn.embibe.com/coobo/school_app_create_prod/images/lti-source-logos/ueducate_square.png",
}
export default {
  name: "LtiSourceLogo",
  props: {},
  data() {
    return {
      logoSrc: "",
    }
  },
  async mounted() {
    const searchParams = new URLSearchParams(window.location.search)
    const source = searchParams.get("source");
    if (source && logos[source]) {
      this.logoSrc = logos[source];
    }
  },
  destroyed() {
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
.lti-source-logo {
  position: fixed;
  z-index: 1000;
  top: 5px;
  right: 5px;
  width: 10vmin;
  height: 10vmin;
  object-fit: contain;
}
</style>
